import { useState, useEffect } from "react";

const useDeviceWidth = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setIsMobile(window.innerWidth < 795); // Assumim que un dispositiu amb una amplada inferior a 795px és un dispositiu mòbil
    };

    window.addEventListener("resize", handleResize);

    // Eliminem l'esdeveniment de l'actualització quan es desmunta el component
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { width, isMobile };
};

export default useDeviceWidth;
